<div class="main-container" style="    margin-top: 0%;">
  <div class="label-bar">
     <label i18n="@@spmsUserReg" class="textColour" style="font-size: 18px;
    font-weight: 500;">Products Group Product Mapping</label>
     <span class="example-spacer"></span>
        <app-common-button
          label="Map Selected Products"
          title="Map Selected Products "
          [buttonId]="114"
          width="150px"
          [critical]="true"
          (clicked)="onAssignSelectedProducts()"
           style="margin-left: 6px;margin-right:6px;"
          >
 
          </app-common-button> 
       <app-common-button
          label="Create Product Group"
          title="Create Product Group "
          [buttonId]="114"
          width="150px"
          [critical]="true"
          (clicked)="onCreateProductGroup()"
           style="margin-left: 6px;margin-right:6px;"
          >
 
          </app-common-button>
  </div>

  <div class="mapping-container">
  <div class="left-panel">
    <div class="panel-header">
      <h3>Product Groups</h3>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Search Product Group</mat-label>
      <input
        matInput
        [(ngModel)]="productGroupSearchText"
        (input)="filterProductGroups()"
        placeholder="Search..."
      />
    </mat-form-field>

    <div class="group-list">
      <div
        *ngFor="let group of filteredProductGroups"
        class="group-item"
        [class.selected]="selectedProductGroup?.productGroupId === group.productGroupId"
        (click)="onProductGroupSelect(group)"
      >
        <div class="group-name">{{ group.productGroupName }}</div>
        <!-- <div class="group-status">{{ group.status }}</div> -->
      </div>
    </div>
  </div>

  <div class="right-panel">
    <div class="right-header">
      <div>
        <div class="role-name-row">
         <h3 style="color:red;">{{ selectedProductGroup?.productGroupName || 'Products' }}</h3>
        <span class="count-pill"
                >{{selectedProducts.length }} Products</span
              >
              </div>
       
        <p class="sub-text" *ngIf="selectedProductGroup">
          Manage products mapped to this product group
        </p>
      </div>

      <div class="header-actions">
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Filter</mat-label>
          <mat-select [(ngModel)]="assignmentFilter" (selectionChange)="applyProductFilter()">
            <mat-option value="ALL">All</mat-option>
            <mat-option value="MAPPED">Mapped</mat-option>
            <mat-option value="UNMAPPED">Unmapped</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search Product</mat-label>
          <input
            matInput
            [(ngModel)]="productSearchText"
            (input)="applyProductFilter()"
            placeholder="Search product..."
          />
        </mat-form-field>
      </div>
    </div>
      <ag-grid-angular
      style="margin-top:-1%;height: 45vh;"
      class="ag-theme-balham"
      [rowData]="filteredRowData"
      [components]="components"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="'multiple'"
       [rowMultiSelectWithClick]="true"
      [suppressRowClickSelection]="true"
      [animateRows]="true"
      [paginationPageSize]="50"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
      [rowHeight]="35"
      [headerHeight]="35"
      [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
      [pagination]="true"
       [suppressPaginationPanel]="true">
    </ag-grid-angular>
    <div class="custom-pagination">
  <span class="range-text">
    {{ startRow }} to {{ endRow }} of {{ totalRows }}
  </span>

  <!-- <button (click)="goToFirst()" [disabled]="currentPage === 1">
     
  </button> -->
  <em class="fas fa-angle-double-left waves-effect waves-light" (click)="goToFirst()"></em>
  <em class="fas fa-angle-left waves-effect waves-light"
                                    (click)="goToPrevious()"></em>
  <!-- <button (click)="goToPrevious()" [disabled]="currentPage === 1">‹</button> -->

  <span class="page-text">
    Page {{ currentPage }} of {{ totalPages }}
  </span>
<em class="fas fa-angle-right waves-effect waves-light" (click)="goToNext()"></em>
<em class="fas fa-angle-double-right waves-effect waves-light" (click)="goToLast()"></em>
  <!-- <button (click)="goToNext()" [disabled]="currentPage === totalPages">›</button>
  <button (click)="goToLast()" [disabled]="currentPage === totalPages">»</button> -->
</div>
    <!-- <div class="grid-wrapper ag-theme-alpine">
      <ag-grid-angular
        style="width: 100%; height: 100%;"
        [columnDefs]="columnDefs"
        [rowData]="filteredRowData"
        [defaultColDef]="defaultColDef"
        [rowSelection]="'multiple'"
        [suppressRowClickSelection]="true"
        [pagination]="true"
        [paginationPageSize]="10"
        (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div> -->

  </div>
</div>
  </div>